export default "__VITE_ASSET__Duz1G876__"